// helpers
import { cn } from "src/utils/common.helper"

export const Input = ({
  id,
  type,
  name,
  hasError = false,
  className = "",
  disabled = false,
  ...rest
}) => {
  return (
    <input
      autoComplete={type === "password" ? "new-password" : "on"}
      disabled={disabled}
      id={id}
      type={type}
      name={name}
      className={cn(
        "block rounded-lg text-base py-2.5 px-3.5 border border-[var(--primary-blue)] focus:border-[var(--border-theme-primary)]",
        { "border-[var(--border-error)]": hasError },
        className
      )}
      {...rest}
    />
  )
}
